// React
import React, { useState, useEffect, useContext, useRef } from "react";
// React
// Skeleton
import { toast } from "react-toastify";
// Skeleton
// CSS
import styles from "./CategoryLessons.module.css";
// CSS
// Services
// Modules
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
// Modules
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Components
import LessonStatus from "./CategoryLessonStatus/CategoryLessonStatus";
import LessonCard from "./CateogoryLessonCard/CategoryLessonCard";
import PendingManager from "../../../Components/PendingManager/PendingManager";
// Components
// Models
import {
  I_SampleExamCategoryLesson,
  I_UserLessonSubject,
} from "../../../Models/interfaces";
// Models
// Contexts
// Contexts
// Images
import { nodata, vidolist_watermark } from "../../../Images/images";
import { _parser } from "../../../Utils/_parser";
import { getSampleCategoriesService } from "../../../Services/SampleExams/get/getSampleCategoriesService";
// Images

const CategoryLessons = () => {
  // States
  const [categories, setCategories] = useState<I_SampleExamCategoryLesson[]>(
    [],
  );
  const [isPending, setIsPending] = useState<boolean>(true);
  // States
  // Constants
  const { lessonId } = useParams();
  const userToken = useContext(UserTokenContext);
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (userToken === "init" || "") return;
    getSampleCategoriesService(userToken, lessonId as string)
      .then(({ data: { data } }) => {
        setIsPending(false);
        setCategories(data);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message,
        );
      });
  }, [userToken, lessonId]);

  if (!state) {
    navigate("/");
    return <></>;
  }

  return (
    <div className={`${styles.teacherContainer} p-4 relative`}>
      <LessonStatus
        customData={"نمونه سوالات امتحانی"}
        imageUrl={String(state.image.url)}
        subjectName={`${state.title}`}
      />
      <div
        className={`${styles.lessonsContainer} px-4 mt-4 bg-white rounded-xl overflow-y-scroll relative flex items-center flex-col `}
      >
        <div className="relative z-20 w-full">
          <PendingManager
            data={
              <>
                {categories.length === 0 ? (
                  <img
                    src={nodata}
                    alt="nodataImg"
                    style={{
                      margin: "0 auto",
                    }}
                  />
                ) : (
                  categories.map((item) => (
                    <LessonCard
                      lessonId={lessonId as string}
                      key={item.id}
                      data={item}
                      state={state}
                    />
                  ))
                )}
              </>
            }
            isPending={isPending}
          />
        </div>
        <img
          src={vidolist_watermark}
          className="w-10/12 opacity-40 fixed z-10 "
          alt=""
          style={{
            bottom: "10vh",
            width: window.innerWidth > 600 ? "590px" : "83%",
          }}
        />
      </div>
    </div>
  );
};

export default CategoryLessons;
